export default "__VITE_ASSET__B4j6r9ZH__"